<template>
    <v-badge
        :value="showBadge"
        color="white"
        bottom
        overlap
        left
        offset-x="16"
        offset-y="16">
        <template #badge>
            <icon color="black" :icon="person.finished ? 'Check' : 'Eye'" x-small />
        </template>
        <v-avatar
            :size="size"
            :color="person.type === 'group' || person.type === 'field' ? 'add-user' : (person.avatar ? 'white add-user' : 'n1 add-user')"
            :class="[className, person.type === 'group' || person.type === 'field' ? 'uku-{0}-avatar'.format(person.type) : '']"
            @click="$emit('click', $event)"
        >
            <img v-if="person.avatar" :alt="person.initials" :src="base_url + person.avatar" />
            <span v-else :class="[text_class, 'font-weight-medium', person.type === 'group' || person.type === 'field'  ? 'white--text' : '']">
                {{ person.initials }}
            </span>
        </v-avatar>
    </v-badge>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: "PersonAvatar",
    props: {
        person: {
            type: Object,
            required: true
        },
        size: {
            type: Number,
            default: 40
        },
        className: {
            type: String,
            default: ""
        }
    },
    setup(props) {
        const protocol = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
        const host = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
        const base_url = `${protocol}://${host}`;

        const text_class = computed(function() {
            if (props.size <= 24) return "caption";
            if (props.size <= 32) return "body-2";
            return "subtitle-1";
        });

        const showBadge = computed(() => Boolean(props.person && (props.person.is_seen || props.person.finished)))

        return {
            base_url,
            text_class,
            showBadge
        };
    }
};
</script>
